import React from "react";

function ServiceCard({ icon, title, description, features, imgSrc }) {
  return (
    <div className="service-card">
      <div className="service-visual-box">
        {/* YAHAN HAI ASLI JADU: Conditional Rendering */}
        {imgSrc ? (
          // Agar imgSrc hai (Item 1 & 2), toh ye dikhao
          <img src={imgSrc} alt={title} className="service-product-img" />
        ) : (
          // Agar imgSrc nahi hai (Baaki items), toh icon dikhao
          <div className="service-icon-box">
            <span className="service-icon">{icon}</span>
          </div>
        )}
      </div>

      <h3 className="service-title">{title}</h3>
      <p className="service-desc">{description}</p>

      {features && (
        <div className="service-features">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <span className="feature-bullet">✓</span>
              <span className="feature-text">{feature}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ServiceCard;
